<template>
  <div class="tw-flex tw-flex-col tw-justify-center tw-items-center">
    <svg-vue
      icon="icons/interface-essential-grid"
      class="tw-text-primary-300 tw-h-8"
    />

    <div class="tw-font-bold tw-text-2xl tw-mt-6 tw-text-neutral-900">
      No Results
    </div>

    <div class="tw-text-base tw-mt-4 tw-text-neutral-700">
      There are currently no results to display
    </div>
  </div>
</template>

